<template>
    <div>
        <template v-if="!isInitialized">
            <div class="block-container">
                <van-empty description="正在读取中..."/>
            </div>
        </template>
        <template v-else-if="fail">
            <div class="block-container">
                <van-empty :description="failMsg"/>
            </div>
        </template>
        <template v-else>
            <div class="invoice-detail">
                <van-form @submit="send">
                    <div class="page-title">换开发票</div>

                    <van-cell title="原开票种类" class="title">
                        <template #label>
                            <span class="field">{{invoiceOrderTypeText}}</span>
                        </template>
                    </van-cell>

                    <van-cell title="原开票订单号" class="title" v-if="invoiceOrderNo">
                        <template #label>
                            <span class="field">{{invoiceOrderNo}}</span>
                        </template>
                    </van-cell>

                    <van-cell title="电子发票号" class="title" v-if="info.electron_invoice_no">
                        <template #label>
                            <span class="field">{{info.electron_invoice_no}}</span>
                        </template>
                    </van-cell>

                    <van-cell title="抬头类型" class="title">
                        <template #label>
                            <van-tabs type="card" v-model="ruleForm.type" class="field" @change="typeChange">
                                <van-tab title="个人抬头" name="personal"></van-tab>
                                <van-tab title="单位抬头" name="company"></van-tab>
                            </van-tabs>
                        </template>
                    </van-cell>

                    <van-cell title="抬头名称" class="title required">
                        <template #label>
                            <van-field
                                v-model="ruleForm.name"
                                :rules="[{ required: true, message: '请填写抬头名称' }]"
                                placeholder="抬头名称"
                                class="field"
                            >
                                <template #button>
                                    <van-icon name="coupon-o" class="icon" size="24px" @click="setTitle = true" />
                                </template>
                            </van-field>
                        </template>
                    </van-cell>

                    <div v-if="ruleForm.type === 'company'">
                        <van-cell title="纳税人识别号" class="title required">
                            <template #label>
                                <van-field
                                    v-model="ruleForm.taxpayer_no"
                                    :rules="[{ required: true, message: '请填写纳税人识别号' }]"
                                    placeholder="纳税人识别号"
                                    class="field"
                                />
                            </template>
                        </van-cell>

                        <van-cell title="企业地址" class="title">
                            <template #label>
                                <van-field v-model="ruleForm.business_address" placeholder="企业地址" class="field" />
                            </template>
                        </van-cell>

                        <van-cell title="电话" class="title">
                            <template #label>
                                <van-field v-model="ruleForm.business_telephone" placeholder="电话" class="field" />
                            </template>
                        </van-cell>

                        <van-cell title="开户行" class="title">
                            <template #label>
                                <van-field v-model="ruleForm.bank_of_deposit" placeholder="开户行" class="field" />
                            </template>
                        </van-cell>

                        <van-cell title="银行账号" class="title">
                            <template #label>
                                <van-field v-model="ruleForm.bank_account" placeholder="银行账号" class="field" />
                            </template>
                        </van-cell>
                    </div>

                    <van-cell title="开票种类" class="title" v-if="isElectronInvoice">
                        <template #label>
                            <van-field
                                :value="displayInvoiceOrderType"
                                readonly
                                clickable
                                placeholder="默认沿用原开票种类"
                                @click="showInvoiceOrderType = true"
                                class="field"
                            >
                            </van-field>
                        </template>
                    </van-cell>

                    <van-cell title="手机号" class="title">
                        <template #label>
                            <van-field v-model="ruleForm.phone" placeholder="手机号" class="field" />
                        </template>
                    </van-cell>

                    <van-cell title="邮箱" class="title">
                        <template #label>
                            <van-field v-model="ruleForm.email" placeholder="邮箱" class="field" />
                        </template>
                    </van-cell>

                    <van-cell title="备注" class="title">
                        <template #label>
                            <van-field v-model="ruleForm.remarks" placeholder="请输入备注" class="field" />
                        </template>
                    </van-cell>

                    <div v-if="isPaperInvoice" class="show">
                        <van-cell title="获取发票方式" class="title" @click="disableMethodMsg">
                            <template>
                                <div style="display: flex; align-items: center; float: right;">
                                    <span class="switch-text">邮寄</span>
                                    <van-switch
                                        v-model="ruleForm.paper_get_invoice_method"
                                        active-value="scene"
                                        inactive-value="post"
                                        active-color="#ee0a24"
                                        inactive-color="#ee0a24"
                                        size="24"
                                        :disabled="!isPostEnable || !isSceneEnable"
                                    />
                                    <span class="switch-text">现场</span>
                                </div>
                            </template>
                        </van-cell>
                    </div>

                    <div v-if="isPaperInvoice && ruleForm.paper_get_invoice_method === 'post'" class="show">
                        <van-cell title="收件人" class="title required">
                            <template #label>
                                <van-field
                                    v-model="ruleForm.receive_name"
                                    :rules="[{ required: true, message: '请填写收件人' }]"
                                    placeholder="收件人"
                                    class="field"
                                />
                            </template>
                        </van-cell>

                        <van-cell title="收件人手机号" class="title required">
                            <template #label>
                                <van-field
                                    v-model="ruleForm.receive_phone"
                                    :rules="[{ required: true, message: '请填写收件人手机号' }]"
                                    placeholder="收件人手机号"
                                    class="field"
                                />
                            </template>
                        </van-cell>

                        <van-cell title="收件人城市" class="title required" @click="showArea = true" is-link>
                            <template #label>
                                <span class="field" style="color: #333">{{receiveAreaText}}</span>
                            </template>
                        </van-cell>

                        <van-cell title="收件地址" class="title required">
                            <template #label>
                                <van-field
                                    v-model="ruleForm.receive_address"
                                    :rules="[{ required: true, message: '请填写收件地址' }]"
                                    placeholder="收件地址"
                                    class="field"
                                />
                            </template>
                        </van-cell>
                    </div>

                    <van-popup v-model="showArea" round position="bottom">
                        <van-area
                            title="选择城市"
                            :area-list="areaList"
                            @confirm="setReceiveArea"
                            @cancel="showArea = false"
                        />
                    </van-popup>

                    <van-popup v-model="setTitle" round position="bottom" class="set-title">
                        <van-nav-bar
                            title="预设抬头"
                            left-text="转至编辑"
                            right-text="返回"
                            @click-left="$router.push({ name : 'InvoiceTitleInfo'})"
                            @click-right="setTitle = false"
                        />
                        <van-pull-refresh v-model="refreshLoading" @refresh="onRefresh" class="invoice_list-container">
                            <van-empty v-if="!invoiceList.length" description="没有开票信息" />
                            <van-list
                                v-model="listLoading"
                                :finished="finished"
                                loading-text="..."
                                @load="onLoad"
                            >
                                <div
                                    v-for="(item, index) in invoiceList"
                                    :key="'invoice-item' + index"
                                    class="invoice-item-container title-cell"
                                    @click="settingInvoiceTitle(item)"
                                >
                                    <van-cell class="invoice-item-card invoice_id">
                                        <template #title>
                                            <div class="invoice-item-headline">
                                                <span class="sub-title">{{invoiceTypes[item.type]}}抬头</span>
                                                <span>{{item.name}}</span>
                                            </div>
                                        </template>
                                    </van-cell>
                                </div>
                            </van-list>
                        </van-pull-refresh>
                    </van-popup>

                    <van-popup v-model="showInvoiceOrderType" round position="bottom">
                        <van-picker
                            show-toolbar
                            :columns="invoiceOrderTypeArr"
                            @confirm="setInvoiceOrderType"
                            value-key="name"
                            @cancel="showInvoiceOrderType = false"
                        />
                    </van-popup>

                    <div v-show="false" :a="isPostOnly" :b="isSceneOnly"></div>
                    <div style="display: flex; justify-content: center; padding: 0.6rem 0;">
                        <van-button type="danger" round class="SubmitBtn" native-type="submit">提交换开</van-button>
                    </div>
                </van-form>
            </div>
        </template>
    </div>
</template>

<script>
    import api from "../../assets/js/api";
    import { areaList } from '@vant/area-data';

    export default {
        name: "InvoiceReissue",
        data() {
            return {
                areaList: areaList,
                isInitialized: false,
                fail: false,
                failMsg: '',
                isLoading: false,
                info: {},
                id: this.$route.query.id || '',
                invoiceOrderNo: this.$route.query.invoice_order_no || '',
                showArea: false,
                ruleForm: {
                    invoice_order_type: '',
                    type: 'company',
                    name: '',
                    phone: '',
                    email: '',
                    taxpayer_no: '',
                    business_address: '',
                    business_telephone: '',
                    bank_of_deposit: '',
                    bank_account: '',
                    remarks: '',
                    paper_get_invoice_method: 'post',
                    receive_name: '',
                    receive_phone: '',
                    receive_province: '',
                    receive_city: '',
                    receive_district: '',
                    receive_address: '',
                },
                cacheTypeInfo: {
                    company: null,
                    personal: null,
                },
                setTitle: false,
                refreshLoading: false,
                listLoading: false,
                invoiceList: [],
                finished: false,
                requestIsLock: false,
                params: {
                    page: 1,
                    pageSize: 10
                },
                showInvoiceOrderType: false,
                siteAllowInvoiceTypeArr: {},
                allowInvoiceTypeArr: [],
                hasAllowInvoiceTypeArr: false,
            };
        },
        created() {
            this.getDetail();
        },
        computed: {
            invoiceTypes() {
                let companyEnum = this.$store.state.systemEnum && this.$store.state.systemEnum.company || {};
                return companyEnum.user_invoice_info && companyEnum.user_invoice_info.type || {};
            },
            invoiceOrderTypeText() {
                let currentInvoiceOrderType = this.info.invoice_order_type || this.ruleForm.invoice_order_type;
                let currentType = this.invoiceOrderTypeArr.find((item) => item.id === currentInvoiceOrderType);
                return currentType && currentType.name || '';
            },
            isElectronInvoice() {
                return this.info.invoice_type === 'electron';
            },
            isPaperInvoice() {
                return this.info.invoice_type === 'paper';
            },
            isPostEnable() {
                return this.$store.state.systemConfig['invoice.is_paper_invoice_post_enable'];
            },
            isSceneEnable() {
                return this.$store.state.systemConfig['invoice.is_paper_invoice_scene_enable'];
            },
            isPostOnly() {
                if (!this.isSceneEnable && this.isPostEnable) {
                    this.ruleForm.paper_get_invoice_method = 'post';
                    return true;
                }
                return false;
            },
            isSceneOnly() {
                if (this.isSceneEnable && !this.isPostEnable) {
                    this.ruleForm.paper_get_invoice_method = 'scene';
                    return true;
                }
                return false;
            },
            invoiceOrderTypeArr() {
                let companyEnum = this.$store.state.systemEnum && this.$store.state.systemEnum.company || {};
                let invoiceOrderType = companyEnum.invoice_order && companyEnum.invoice_order.invoice_type || {};
                let isQuotaInvoice = !this.info.invoice_user_order_no || !this.info.invoice_user_order_no.length;
                let currentSiteId = this.info.site_id || this.ruleForm.site_id;
                let allowInvoiceTypeArr = Array.isArray(this.allowInvoiceTypeArr) ? this.allowInvoiceTypeArr : [];
                let siteAllowInvoiceTypeArr = this.siteAllowInvoiceTypeArr || {};
                let currentSiteAllowInvoiceTypeArr = Array.isArray(siteAllowInvoiceTypeArr[currentSiteId]) ? siteAllowInvoiceTypeArr[currentSiteId] : [];
                let arr = [];
                for (let key in invoiceOrderType) {
                    let disabled = false;
                    if (this.hasAllowInvoiceTypeArr) {
                        if (isQuotaInvoice) {
                            disabled = currentSiteAllowInvoiceTypeArr.indexOf(key) === -1;
                        } else {
                            disabled = allowInvoiceTypeArr.indexOf(key) === -1;
                        }
                    }
                    arr.push({
                        id: key,
                        name: invoiceOrderType[key],
                        disabled: disabled,
                    });
                }
                return arr;
            },
            displayInvoiceOrderType() {
                let type = this.invoiceOrderTypeArr.find((item) => item.id === this.ruleForm.invoice_order_type);
                return (type && type.name) || '';
            },
            receiveAreaText() {
                let text = `${this.ruleForm.receive_province} ${this.ruleForm.receive_city} ${this.ruleForm.receive_district}`.trim();
                return text || '请选择收件人城市';
            },
        },
        methods: {
            getDetail() {
                let self = this;
                if (!this.id) {
                    self.fail = true;
                    self.failMsg = '缺少开票记录ID';
                    self.isInitialized = true;
                    return;
                }
                let loading = this.$toast.loading({
                    message: '加载中...',
                    forbidClick: true,
                    loadingType: 'spinner',
                    duration: 0,
                });
                api.request('/invoice/detail', {
                    id: this.id
                }).then(res => {
                    let detail = res.data || {};
                    self.info = detail;
                    self.invoiceOrderNo = detail.invoice_order_no || self.invoiceOrderNo;
                    self.ruleForm = {
                        ...self.ruleForm,
                        invoice_order_type: detail.invoice_order_type || '',
                        site_id: detail.site_id || '',
                        type: detail.type || self.ruleForm.type,
                        name: detail.name || '',
                        phone: detail.phone || '',
                        email: detail.email || '',
                        taxpayer_no: detail.taxpayer_no || '',
                        business_address: detail.business_address || '',
                        business_telephone: detail.business_telephone || '',
                        bank_of_deposit: detail.bank_of_deposit || '',
                        bank_account: detail.bank_account || '',
                        remarks: detail.remarks || '',
                        paper_get_invoice_method: detail.paper_get_invoice_method || ((detail.receive_name || detail.receive_phone || detail.receive_address) ? 'post' : 'scene'),
                        receive_name: detail.receive_name || '',
                        receive_phone: detail.receive_phone || '',
                        receive_province: detail.receive_province || '',
                        receive_city: detail.receive_city || '',
                        receive_district: detail.receive_district || '',
                        receive_address: detail.receive_address || '',
                    };
                    return self.loadPreviewInfo();
                }).catch(res => {
                    self.fail = true;
                    self.failMsg = res.msg;
                }).finally(() => {
                    self.isInitialized = true;
                    self.$toast.clear(loading);
                });
            },
            setReceiveArea(data) {
                this.showArea = false;
                this.ruleForm.receive_province = data[0].name || '';
                this.ruleForm.receive_city = data[1].name || '';
                this.ruleForm.receive_district = data[2].name || '';
            },
            setInvoiceOrderType(data) {
                this.showInvoiceOrderType = false;
                if (data.disabled) return;
                this.ruleForm.invoice_order_type = data.id || '';
            },
            normalizeInvoiceOrderType() {
                let currentType = this.invoiceOrderTypeArr.find((item) => item.id === this.ruleForm.invoice_order_type);
                if (!currentType || currentType.disabled) {
                    let firstEnabledType = this.invoiceOrderTypeArr.find((item) => !item.disabled);
                    this.ruleForm.invoice_order_type = firstEnabledType ? firstEnabledType.id : '';
                }
            },
            loadPreviewInfo() {
                let previewParams = {};
                let invoiceUserOrderNo = Array.isArray(this.info.invoice_user_order_no) ? this.info.invoice_user_order_no : [];
                if (invoiceUserOrderNo.length) {
                    previewParams.order_no = invoiceUserOrderNo;
                }
                return api.request('/invoice/preview', previewParams).then(res => {
                    this.siteAllowInvoiceTypeArr = res.data && res.data.site_allow_invoice_type_arr || {};
                    this.allowInvoiceTypeArr = res.data && Array.isArray(res.data.allow_invoice_type_arr) ? res.data.allow_invoice_type_arr : [];
                    this.hasAllowInvoiceTypeArr = !!(res.data && (
                        Object.prototype.hasOwnProperty.call(res.data, 'allow_invoice_type_arr') ||
                        Object.prototype.hasOwnProperty.call(res.data, 'site_allow_invoice_type_arr')
                    ));
                    this.normalizeInvoiceOrderType();
                }).catch(() => {
                    this.siteAllowInvoiceTypeArr = {};
                    this.allowInvoiceTypeArr = [];
                    this.hasAllowInvoiceTypeArr = false;
                });
            },
            send() {
                let self = this;
                if (!self.id && !self.invoiceOrderNo) {
                    this.$dialog({
                        message: '缺少原开票记录信息，无法换开'
                    });
                    return;
                }
                if (self.isLoading) return;
                if (self.isElectronInvoice) {
                    self.normalizeInvoiceOrderType();
                }

                let isCompany = self.ruleForm.type === 'company';
                let params = {
                    invoice_order_no: self.invoiceOrderNo || '',
                    id: self.id || '',
                    type: self.ruleForm.type || 'personal',
                    name: self.ruleForm.name || '',
                    taxpayer_no: isCompany ? (self.ruleForm.taxpayer_no || '') : '',
                    business_address: isCompany ? (self.ruleForm.business_address || '') : '',
                    business_telephone: isCompany ? (self.ruleForm.business_telephone || '') : '',
                    bank_of_deposit: isCompany ? (self.ruleForm.bank_of_deposit || '') : '',
                    bank_account: isCompany ? (self.ruleForm.bank_account || '') : '',
                    remarks: self.ruleForm.remarks || '',
                    phone: self.ruleForm.phone || '',
                    email: self.ruleForm.email || '',
                };

                if (self.ruleForm.invoice_order_type) {
                    params.invoice_order_type = self.ruleForm.invoice_order_type;
                }

                if (self.isPaperInvoice) {
                    params.paper_get_invoice_method = self.ruleForm.paper_get_invoice_method || '';
                    params.receive_name = self.ruleForm.paper_get_invoice_method === 'post' ? (self.ruleForm.receive_name || '') : '';
                    params.receive_phone = self.ruleForm.paper_get_invoice_method === 'post' ? (self.ruleForm.receive_phone || '') : '';
                    params.receive_province = self.ruleForm.paper_get_invoice_method === 'post' ? (self.ruleForm.receive_province || '') : '';
                    params.receive_city = self.ruleForm.paper_get_invoice_method === 'post' ? (self.ruleForm.receive_city || '') : '';
                    params.receive_district = self.ruleForm.paper_get_invoice_method === 'post' ? (self.ruleForm.receive_district || '') : '';
                    params.receive_address = self.ruleForm.paper_get_invoice_method === 'post' ? (self.ruleForm.receive_address || '') : '';
                }

                self.isLoading = true;
                let loading = this.$toast.loading({
                    message: '加载中...',
                    forbidClick: true,
                    loadingType: 'spinner',
                    duration: 0,
                });
                api.request('/invoice/reissue', params).then(res => {
                    self.$toast.clear();
                    self.$dialog({
                        message: res.msg
                    }).then(() => {
                        self.$router.back();
                    });
                }).catch(res => {
                    self.$toast.clear();
                    self.$dialog({
                        message: res.msg
                    });
                }).finally(() => {
                    self.isLoading = false;
                    self.$toast.clear(loading);
                });
            },
            onRefresh() {
                if (this.requestIsLock) return;
                this.finished = false;
                this.refreshLoading = true;
                this.params.page = 1;
                this.getInvoiceList();
            },
            onLoad() {
                if (this.requestIsLock) return;
                this.getInvoiceList();
            },
            getInvoiceList() {
                this.requestIsLock = true;
                api.request('/user_invoice_info/list', {
                    page: this.params.page,
                    page_size: this.params.pageSize,
                }).then(res => {
                    if (this.refreshLoading) {
                        this.invoiceList = [];
                        this.refreshLoading = false;
                    }
                    if (res.data.data && res.data.data.length) {
                        this.params.page++;
                        this.invoiceList = this.invoiceList.concat(res.data.data);
                    }
                    if (this.invoiceList.length >= res.data.total) {
                        this.finished = true;
                    }
                }).finally(() => {
                    this.listLoading = false;
                    this.requestIsLock = false;
                });
            },
            settingInvoiceTitle(item) {
                let keys = Object.keys(this.ruleForm);
                for (let itemKey in item) {
                    if (keys.indexOf(itemKey) > -1) {
                        this.ruleForm[itemKey] = item[itemKey];
                    }
                }
                this.setTitle = false;
            },
            disableMethodMsg() {
                if (this.isSceneOnly) {
                    this.$toast('暂不支持邮寄纸质发票');
                } else if (this.isPostOnly) {
                    this.$toast('暂不支持现场获取纸质发票');
                }
            },
            typeChange() {
                let prevType = this.ruleForm.type === 'company' ? 'personal' : 'company';
                let currentType = this.ruleForm.type;
                this.cacheTypeInfo[prevType] = {
                    name: this.ruleForm.name,
                    taxpayer_no: this.ruleForm.taxpayer_no,
                    business_address: this.ruleForm.business_address,
                    business_telephone: this.ruleForm.business_telephone,
                    bank_of_deposit: this.ruleForm.bank_of_deposit,
                    bank_account: this.ruleForm.bank_account,
                };
                let currentCache = this.cacheTypeInfo[currentType];
                if (currentCache) {
                    this.ruleForm.name = currentCache.name;
                    this.ruleForm.taxpayer_no = currentCache.taxpayer_no;
                    this.ruleForm.business_address = currentCache.business_address;
                    this.ruleForm.business_telephone = currentCache.business_telephone;
                    this.ruleForm.bank_of_deposit = currentCache.bank_of_deposit;
                    this.ruleForm.bank_account = currentCache.bank_account;
                } else {
                    this.ruleForm.name = '';
                    this.ruleForm.taxpayer_no = '';
                    this.ruleForm.business_address = '';
                    this.ruleForm.business_telephone = '';
                    this.ruleForm.bank_of_deposit = '';
                    this.ruleForm.bank_account = '';
                }
            },
        },
    }
</script>

<style lang="scss" scoped>
    .show {
        animation: 0.5s linear 0s normal show-form;
        overflow: hidden;
    }

    @keyframes show-form {
        0% {
            max-height: 0;
        }
        100% {
            max-height: 500px;
        }
    }

    .invoice-detail {
        margin: 10px;
        background: #fff;

        .page-title {
            padding: 0.4rem;
            font-size: 0.5rem;
            font-weight: bolder;
        }

        .required {
            &::before {
                position: absolute;
                left: 0.21333rem;
                color: #ee0a24;
                font-size: 0.37333rem;
                content: '*';
            }
        }

        .title {
            color: #333;
            font-size: 15px;
            font-weight: bold;
        }

        .field {
            padding: 0;
            font-size: 14px;
            font-weight: lighter;
        }

        .SubmitBtn {
            margin: 0;
            width: 75vw;
        }

        .switch-text {
            font-weight: lighter;
            font-size: 14px;
            line-height: 24px;
            margin: 0 5px;
            color: #333;
        }
    }

    .set-title {
        height: 80%;

        .invoice_list-container {
            .invoice-item-container {
                margin: 10px;
                border-radius: 10px;
                background: #ffffff;
                box-shadow: 0 0 5px 0 rgba(0, 0, 0, .05);
                overflow: hidden;
                border: #ccc solid 0.1px;

                .invoice-item-headline {
                    span {
                        display: block;
                        font-size: 16px;
                        color: #333;
                    }

                    .sub-title {
                        font-size: 12px;
                        color: #bbb;
                    }
                }
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/pages/invoice/InvoiceReissue.vue